export default function carBrands() {

  const carBrandItems = document.querySelectorAll('#sliderCarModel .slider-car-model__content')
  const brandSlides = document.querySelectorAll('#sliderCarModel .swiper-slide');

  if (carBrandItems.length === 0) return

  carBrandItems.forEach(item => {
    item.addEventListener('pointerover', onPointerover)
    item.addEventListener('pointerout', onPointerout)
  })

  function onPointerover(e) {
    const targetItem = e.target.closest('.slider-car-model__content')

    for (const item of carBrandItems) {
      if (item === targetItem) {
        item.classList.add('active')
      }
      else {
        item.classList.remove('active')
        item.classList.add('inactive')
      }
    }

  }

  function onPointerout(e) {
    for (const item of carBrandItems) {
      item.classList.remove('active')
      item.classList.remove('inactive')

    }
  }


  if (1) {
    if (brandSlides.length) {
      for (let slide of brandSlides) {
        slide.addEventListener('mouseenter', () => {
          // 1. Останавливаем автопрокрутку
          window.swiper2.autoplay.stop();

          // 2. Мгновенно прерываем анимацию, фиксируя текущий translate
          window.swiper2.setTranslate(window.swiper2.getTranslate());

          // 3. Отключаем переходы (опционально)
          //window.swiper2.wrapperEl.style.transition = 'none';
        });

        // При уходе курсора возвращаем обычное поведение
        slide.addEventListener('mouseleave', () => {
          //console.log('1', );
          // Восстанавливаем переходы
          //window.swiper2.wrapperEl.style.transition = '';

          // Запускаем автопрокрутку снова
          window.swiper2.autoplay.start();
          /* setTimeout(() => {
            console.log('', window.swiper2.autoplay.start());
          }, 500); */
        });
      }
    }
  }








}
